
<form name="tableItemEditForm" #tableItemEditForm="ngForm">
  <fieldset [disabled]="hasIfedoraChave(item.ifedore_chav)">

    <div class="row">

      <!--Tipo de documento-->
      <div class="col-sm-6">
        <div class="form-group">
          <label for="DesignationTypeCode"><span class="mandatory">*</span>{{'CardDocumentation.DocumentsTable.Designation' | translate}}</label>
          <select class="custom-select"
                  [(ngModel)]="item.designationTypeCode"
                  name="designationTypeCode" #designationTypeCode="ngModel" required
                  [disabled]="item.isMandatoryFile?.toString()=='true'"
                  [dropdownTitle]="{value : item.designationTypeCode, dimensions : designationTypes }" nullableSelect
                  (change)="docDesignationChanged()">
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of designationTypes" [value]="domain.value">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="designationTypeCode"></validation-message>
        </div>
      </div>

      <!--Identificação-->
      <div class="col-sm-6">
        <div class="form-group">
          <label for="beneficiaryID">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.Owner' | translate}}
          </label>
          <select class="custom-select"
                  [(ngModel)]="item.beneficiaryID"
                  name="beneficiaryID" #beneficiaryID="ngModel" required
                  (change)="nameChanged()"
                  [disabled]="item.isMandatoryFile?.toString()=='true'"
                  nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of beneficiariesList" [value]="domain.value">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="beneficiaryID"></validation-message>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-sm-10" *ngIf="item.designationTypeCode == documentsValue.FaturaOuRecibo">
        <span class=" " style="font-weight:bold;font-size :100%;color:var(--bs-body-color);">
          {{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.Designation2' | translate}}
        </span>
      </div>
    </div>


    <div class="row">
      <div class="col-sm-12" [hidden]="!((item.fileID && isEdit) || uploadedFile)">
        <div class="fileinput-custom-1" (click)="downloadDocument()">
          <div class="content-file-wrapper">
            <div class="d-flex align-items-center">
              <span class="icon-doc"></span>
              <span class="text-file">
                <p class="m-0 text-filename">{{item.fileName}}</p>
                <p class="m-0 min-text">{{item.fileSizeKB}}KB</p>
              </span>
            </div>

            <button type="button" class="btn-icon text-primary hide-on-fieldset" aria-label="Editar" (click)="onClearFile(isEdit,true)">
              <span class="p-1 text-primary icon-trash"></span>
              &nbsp;Limpar
            </button>

          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12" [hidden]="item.fileID || uploadedFile">
        <div class="fileinput-custom-2" appDrag (files)="onFileDropped($event)">
          <i class="icon-upload text-primary" aria-hidden="true"></i>
          <span>
            <label class="fileinput-bold-text">{{'CardDocumentation.DocumentsTable.File' | translate}}&nbsp;</label>
            <input class="form-control" type="file" id="input-file" #file name="file" accept="application/pdf" (click)="this.item.fileID=null;item.file= null;" (change)="onFileSelected($event)" [required]="true" style="display: none;">
            <a class="text-secondary"><label for="input-file" class="fileinput-bold-text"> {{'CardDocumentation.DocumentsTable.Find' | translate}}</label></a>
          </span>
          <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ValidNameMessage1' | translate}}</span>
          <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ValidNameMessage2' | translate}}</span>
          <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ExtensionAndSize1' | translate}}</span>
          <span class="fileinput-custom-text-responsive">{{'CardDocumentation.DocumentsTable.ExtensionAndSize2' | translate}}</span>
          <span *ngIf="invalidFileSize" class="fileinput-custom-text-responsive" style="color:red">O ficheiro que pretende adicionar está vazio</span>
          <span *ngIf="invalidExceedsFileSize" class="fileinput-custom-text-responsive" style="color:red">O ficheiro excede o tamanho máximo permitido</span>
          <span *ngIf="invalidPDFFile" class="fileinput-custom-text-responsive" style="color:red">O formato do ficheiro que pretende adicionar não corresponde à sua extensão!</span>
          <span *ngIf="invalidFileFormat" class="fileinput-custom-text-responsive" style="color:red">O tipo de ficheiro fornecido não é válido.</span>
          <validation-message [control]="file"></validation-message>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-2"></div>
      <div class="col-sm-6">
        <div class="form-group">
          <!--se o tipo de documento for diferente de certidão-->
          <ng-context *ngIf="(item.designationTypeCode!= documentsValue.CertidaoNascRequerente &&  item.designationTypeCode!=documentsValue.CertidaoNascFalecido &&  item.designationTypeCode!=documentsValue.CertidaoNascReprLegal);else certidao ">
            <!-- File description-->
            <label for="fileDescription" [class.disabled]="item.designationTypeCode!= documentsValue.OutroMeioProva">
              <span *ngIf="item.designationTypeCode==documentsValue.OutroMeioProva" class="mandatory">*</span>
              {{'CardDocumentation.DocumentsTable.Name' | translate}}
            </label>

            <input class="form-control" name="fileDescription"
                   [(ngModel)]="item.fileDescription"
                   [disabled]="item.designationTypeCode!= documentsValue.OutroMeioProva"
                   [required]="item.designationTypeCode==  documentsValue.OutroMeioProva"
                   #fileDescription="ngModel"
                   maxlength="100" />
            <validation-message [control]="fileDescription"></validation-message>
          </ng-context>
          <ng-template #certidao>
            <!-- File description-->
            <label for="fileDescription">
              <span class="mandatory">*</span>
              {{'PrestacoesMorte.StepDocumentsPM.CardDocumentation.DocumentsTable.CertidaoCodigo' | translate}}
            </label>

            <input style="text-transform:uppercase" class="form-control" name="fileDescription"
                   [(ngModel)]="item.fileDescription"
                   type="text"
                   mask="AAAA-AAAA-AAAA" [validation]="true"
                   [dropSpecialCharacters]="false"
                   placeholder="XXXX-YYYY-ZZZZ"
                   required
                   #fileDescription="ngModel"
                   maxlength="100" />
            <validation-message message="O formato deve de ser XXXX-YYYY-ZZZZ" [control]="fileDescription"></validation-message>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <!-- File observations-->
          <label for="Observations">{{'CardDocumentation.DocumentsTable.Observations' | translate}}</label>

          <textarea class="form-control" name="observation"
                    placeholder="{{'CardDocumentation.DocumentsTable.ObservationsPlaceholder' | translate}}"
                    [(ngModel)]="item.fileObservation"
                    #observation="ngModel"
                    rows="2" cols="150"
                    maxlength="100"> </textarea>
          <validation-message [control]="observation"></validation-message>
        </div>
      </div>
    </div>
  </fieldset>
</form>



<div class="d-flex justify-content-between mt-4 mb-2">
  <button  type="button" class="btn btn-outline-primary disable-on-fieldset"
           [disabled]="hasIfedoraChave(item.ifedore_chav)" (click)="onRemove(isEdit)">
    <span [ngClass]="isEdit ? 'icon-trash' : 'icon-close'"></span>
    <span>{{isEdit ?  'Remover' : 'Cancelar'}}</span>
  </button>
  <button type="button" [disabled]="!item.file || hasIfedoraChave(item.ifedore_chav)" class="btn btn-primary disable-on-fieldset" aria-label="Aplicar" (click)="onEdit(isEdit)"><span class="icon-check"></span><span>Aplicar</span></button>
</div>
